<template>
  <div >
    <div class="tree-container" v-if="dataSource">
      <div class="user-super-container">
        <!-- 画当前节点 -->
        <div class="user-wife-container">
          <!-- 有妻子 有儿子的情况下 给当前节点添加22.5px的右侧内边距-->
          <div
            class="user-container"
            :style="{
              paddingRight:
                dataSource.wife && dataSource.children ? '11.25px' : '0',
            }"
          >
            <!-- 每个子节点头部画一个垂直的线  根节点除外 -->
            <div v-if="!isRoot" class="vertical-line" />
            <!-- 用户信息 -->
            <div class="user-info" v-if="dataSource.thumb" @click="itemClick(dataSource)">
              <img class="user-avatar" :src="dataSource.thumb"  />
              <div class="user-name">
                <div class="user-name-text">{{ dataSource.username }}</div>
                <img
                  v-if="dataSource.gender == '1'"
                  class="user-sex"
                  src="../assets/img/icon_sex_woman.png"
                />
                <img
                  v-if="dataSource.gender == '0'"
                  class="user-sex"
                  src="../assets/img/icon_sex_man.png"
                />
              </div>
            </div>

            <div class="user-info" v-if="!dataSource.thumb" @click="itemClick(dataSource)"  >
              <img
                v-if="dataSource.gender == 0"
                class="user-avatar"
                src="../assets/img/icon_default_man.png"
              />

              <img
                v-if="dataSource.gender == 1"
                class="user-avatar"
                src="../assets/img/icon_default_woman.png"
              />

              <div class="user-name">
                <div class="user-name-text">{{ dataSource.username }}</div>
                <img
                  v-if="dataSource.gender == '1'"
                  class="user-sex"
                  src="../assets/img/icon_sex_woman.png"
                />
                <img
                  v-if="dataSource.gender == '0'"
                  class="user-sex"
                  src="../assets/img/icon_sex_man.png"
                />
              </div>
            </div>

            <!-- 如果当前节点有儿子 有妻子 在节点下方画一条垂直的线 -->
            <div
              v-if="dataSource.children && dataSource.wife"
              class="vertical-line"
            />
          </div>

          <!-- 处理配偶 -->
          <!-- 如果有配偶 没儿子  则画一根水平线关联夫妻关系 -->
          <div
            v-if="!dataSource.children && dataSource.wife"
            class="horizontal-line"
            style="width:17.5px;margin-left:2.5px;margin-right:2.5px;"
          />

          <!-- 有妻子 没有儿子的情况下 给当前配偶节点添加22.5px的左侧内边距-->
          <div
            v-if="dataSource.wife"
            class="user-container"
            :style="{
              paddingLeft:
                dataSource.wife && dataSource.children ? '11.25px' : '0',
            }"
          >
            <!-- 每个子节点头部画一个垂直的线 由于是配偶  要透明处理 -->
            <div
              v-if="!isRoot"
              class="vertical-line"
              style="backgroundColor:rgba(0,0,0,0)"
            />
            <!-- 用户信息 -->
            <div class="user-info" v-if="dataSource.wife.thumb" @click="itemClick(dataSource.wife)">
              <img class="user-avatar" :src="dataSource.wife.thumb" />

              <div class="user-name">
                <div class="user-name-text" v-if="dataSource.wife">
                  {{ dataSource.wife.username }}
                </div>
                <img
                  v-if="dataSource.wife.gender == '1'"
                  class="user-sex"
                  src="../assets/img/icon_sex_woman.png"
                />
                <img
                  v-if="dataSource.wife.gender == '0'"
                  class="user-sex"
                  src="../assets/img/icon_sex_man.png"
                />
              </div>
            </div>

            <div class="user-info" v-if="!dataSource.wife.thumb"  @click="itemClick(dataSource.wife)" >
              <img
                v-if="dataSource.wife.gender == 0"
                class="user-avatar"
                src="../assets/img/icon_default_man.png"
              />

              <img
                v-if="dataSource.wife.gender == 1"
                class="user-avatar"
                src="../assets/img/icon_default_woman.png"
              />

              <div class="user-name">
                <div class="user-name-text" v-if="dataSource.wife">
                  {{ dataSource.wife.username }}
                </div>
                <img
                  v-if="dataSource.wife.gender == '1'"
                  class="user-sex"
                  src="../assets/img/icon_sex_woman.png"
                />
                <img
                  v-if="dataSource.wife.gender == '0'"
                  class="user-sex"
                  src="../assets/img/icon_sex_man.png"
                />
              </div>
            </div>

            <!-- 如果当前节点有儿子 在配偶下方画一条垂直的线 -->
            <div v-if="dataSource.children" class="vertical-line" />
          </div>
        </div>
        <!-- 如果当前节点有儿子并且有配偶 在夫妻下方画一条水平的线 并设置左下 右下圆角 -->
        <div
          v-if="dataSource.children && dataSource.wife"
          class="horizontal-line left-bottom-radius right-bottom-radius"
        />
      </div>

      <!-- 有多个儿子 先要画一条垂直的线 再画一条水平的线 -->

      <div
        v-if="dataSource.children && dataSource.children.length > 1"
        class="vertical-line"
      ></div>

      <!-- 渲染子节点 如果他的下级最后一个子节点有配偶 则下级的整个布局向右移动144px -->
      <div
        v-if="dataSource.children && dataSource.children.length >0"
        class="children-container"
        :style="{
          marginLeft: dataSource.children[dataSource.children.length - 1].wife
            ? '72px'
            : '0',
        }"
      >
        <div
          class="children-super"
          v-for="(itemchild, index) in dataSource.children"
          :key="index"
        >
          <template v-if="dataSource.children.length > 1">
            <template v-if="itemchild.wife">
              <!-- 第一个的情况 -->
              <div
                v-if="index == 0"
                class="horizontal-line left-top-radius first-wife-line"
              ></div>
              <!-- 最后一个 -->
              <div
                v-else-if="index == dataSource.children.length - 1"
                class="horizontal-line left-top-radius last-wife-line"
              ></div>

              <!-- 中间的 -->
              <div v-else class="horizontal-line" style="width:100%"></div>
            </template>

            <template v-if="!itemchild.wife">
              <!-- 第一个的情况 -->
              <div
                v-if="index == 0"
                class="horizontal-line left-top-radius first-line"
              ></div>
              <!-- 最后一个 -->
              <div
                v-else-if="index == dataSource.children.length - 1"
                class="horizontal-line left-top-radius last-line"
              ></div>
              <!-- 中间的 -->
              <div v-else class="horizontal-line" style="width:100%"></div>
            </template>
          </template>

          <my-tree  :dataSource="itemchild" ></my-tree>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EnentVue from './eventVue'
export default {
  name: "myTree",
  props: {
    dataSource: {
      type: Object,
      defaut: function() {
        return {};
      },
    },
    isRoot: Boolean,
  },

    methods: {
      
      

      itemClick: function (event) {
         EnentVue.$emit('NOTI_TREECLICK',event);

      }
    }

};
</script>

<style>
.imagebutt {
  margin-top: 10px;
  margin-left: 90%;
  width: 40px;
  height: 40px;
}
.tree-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.user-super-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.user-wife-container {
  display: flex;
  align-items: center;
  padding-left: 11.25px;
  padding-right: 11.25px;
}

.user-container {
  width: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.user-info {
  overflow: hidden;
}

.user-avatar {
  margin-top: 2.5px;
  height: 48px;
  width: 48px;
  display: block;
  border-radius: 50%;
  background-color: white;
}

.user-name {
  width: 48px;
  height: 16px;
  border-radius: 2px;
  background-color: #fff;
  display: flex;
  margin-top: 6px;
  margin-bottom: 2.5px;
  border: 1px solid rgb(245, 245, 245);
}

.user-name-text {
  font-size: 10px;
  width: 40px;
  margin-left: 1px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  /* text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  align-content: center; */
}

.user-sex {
  height: 6px;
  width: 7px;
}

.user-self {
  color: white;
  background-color: #c69b2f;
}

.vertical-line {
  height: 12.5px;
  width: 2px;
  background-color: #777;
}

.horizontal-line {
  width: calc(50% + 2px);
  height: 2px;
  background-color: #777;
}

.left-bottom-radius {
  border-bottom-left-radius: 1px;
}

.right-bottom-radius {
  border-bottom-right-radius: 1px;
}

.left-top-radius {
  border-top-left-radius: 1px;
}

.right-top-radius {
  border-top-right-radius: 1px;
}

.children-container {
  display: flex;
  flex-direction: row;
}

.children-super {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.first-wife-line {
  width: calc(50% + 11.25px + 25px);
  margin-left: calc(50% - 11.25px - 25px);
}

.first-line {
  width: calc(50% + 1px);
  margin-left: calc(50% - 1px);
}

.last-wife-line {
  width: calc(50% - 11.25px - 23px);
  margin-right: calc(50% + 11.25px + 23px);
}

.last-line {
  width: calc(50% + 1px);
  margin-right: calc(50% - 1px);
}

.placeholder-view {
  width: 62.5px;
  background-color: white;
}

.hexietp {
  margin-left: 4px;
  margin-top: 4px;
  width: 6px;
  height: 6px;
  background-color: #32cd32;
  position: fixed;
  z-index: 2;
  border-radius: 3px;
}
</style>
